import {action} from 'mobx';

import apiCollectionGetAllStore from './apiCollectionGetAllStore';
import ApiBaseStore from '../common/apiBaseStore';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';

/**
 * ApiCollectionUpdateStore
 */
class ApiCollectionUpdateStore extends ApiBaseStore {
  /**
   * Updates collection through the api.
   *
   * @param {number} collectionId
   * @param {string} collectionName
   */
  @action makeRequest(collectionId, collectionName) {
    if (!collectionId) {
      this.state = STATE_REJECTED;
      this.error = new Error('Invalid collection id given to collectionUpdate.');
      return;
    }

    const safeCollectionId = String(collectionId);

    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    const safeUpdateCollection = {
      name: collectionName,
    };

    serverApi.collectionRename(
      safeCollectionId,
      safeUpdateCollection
    ).then(
      action('collectionUpdateSuccess', () => {
        this.error = null;
        this.state = STATE_FULFILLED;
        this.data = true;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        // Clear the collection cache.
        apiCollectionGetAllStore.refresh(true);
      }),
      action('collectionUpdateError', (error) => {
        this.error = error;
        this.state = STATE_REJECTED;
        this.data = false;
      })
    );
  }
}

export default new ApiCollectionUpdateStore();
